import {initWebComponent} from "@/helpers/web-component-helper";
import {setInfoValue} from "@/helpers/info-overview-helper";
import {showNotification} from "@/helpers/toastr-helper";
import $ from "jquery";

const template = document.createElement('template');

export class FormDomainListItemComponent extends HTMLElement {
    constructor() {
        super();
        const name = this.getAttribute('data-name')
        const comment = this.getAttribute('data-comment')
        const attributeID = this.getAttribute('data-attribute-id')
        const image = this.getAttribute('data-image')

        const childName = this.getAttribute('data-child-name')
        const parentName = this.getAttribute('data-parent-name')

        let innerHtml = `<div class="list-group mt-2">
            <a class="list-group-item list-group-item-action list-item-hoofdcategorie" data-toggle="list" href="#">
            <div style="margin-top:3px">` + name

        if(image !== null && image !== "null") {
            innerHtml += `<img class="img-responsive float-right" src="` + image + `" width="26px">`
        }

        innerHtml += `</div>   
                </a>
        </div>`

        innerHtml += ` </div>`

        template.innerHTML = innerHtml

        initWebComponent(this, template)

        this.addEventListener('click',  (element) => {

            if(comment) {
                showNotification(comment, '', 'warning')

                $('.sw-btn-next').prop('disabled', true)
            } else {
                $('.sw-btn-next').prop('disabled', false)
            }

            this.parentElement.querySelectorAll('.list-group-item-action').forEach((element) => {
                element.classList.remove('active')
            })

            this.getElementsByClassName('list-group-item-action')[0].classList.add('active')
            setInfoValue(attributeID, name)

            let wizardItem
            window.wizard.Items.map( item => {
                item.Items.map( childItem => {
                    if( childItem.Attribute === childName && childItem.AttributeTypeID !== null) {
                        wizardItem = childItem
                    }
                })
            })

            if(wizardItem) {

                const element = document.querySelector('form-domain-list-single[data-attribute-id="' + wizardItem.AttributeID + '"]')
                if(element) {

                    let isRequired = ''
                    if(wizardItem.IsRequired) {
                        isRequired = '*'
                    }

                    element.innerHTML =
                        `<form-domain-list-single data-is-required="${isRequired}" data-name="${wizardItem.Name}" data-attribute-id="${wizardItem.AttributeID }"></form-domain-list-single>`
                }
            }
        })
    }
}
